import React from 'react';
import { styled } from '@compiled/react';
import AkCalendar from '@atlaskit/calendar';
import { token } from '@atlaskit/tokens';
import { DATE_FORMAT_DASH } from '../../../../common/constants';
import type { ChangeEvent, DatePickerProps } from '../../../../common/types';
import { formatDate, getDate, getDay, getMonth, getYear } from '../../../../common/utils/dates';
import { useCalendar } from './utils/use-calendar';
import { useDisabledDates } from './utils/use-disabled-dates';

type Props = DatePickerProps & {
	selected?: Date;
	testId?: string;
	onSelect?: (date: Date) => void;
};

const Calendar = ({
	disabledDates,
	disableFuture = false,
	disablePast = false,
	minDate,
	maxDate,
	onSelect,
	selected,
	testId,
}: Props) => {
	const { calendarDate, setCalendar } = useCalendar(selected, {
		disableFuture,
		disablePast,
		minDate,
		maxDate,
	});

	const disabled = useDisabledDates({
		disabledDates,
		disablePast,
		disableFuture,
		minDate,
		maxDate,
	});

	const changeHandler = ({ iso, type }: ChangeEvent) => {
		if (iso !== undefined) {
			const date = getDate(iso);
			if (date instanceof Date) {
				setCalendar(date, type);
			}
		}
	};

	const selectHandler = ({ iso }: ChangeEvent) => {
		if (iso !== undefined && onSelect) {
			const date = getDate(iso);
			if (date instanceof Date) {
				onSelect(date);
			}
		}
	};
	return (
		<CalendarWrapper>
			<AkCalendar
				testId={testId}
				disabled={disabled}
				day={getDay(calendarDate)}
				month={getMonth(calendarDate)}
				year={getYear(calendarDate)}
				onChange={changeHandler}
				// @ts-expect-error - TS2322 - Type '({ iso }: ChangeEvent) => void' is not assignable to type '(event: SelectEvent, analyticsEvent: UIAnalyticsEvent) => void'.
				onSelect={selectHandler}
				selected={selected ? [formatDate(selected, DATE_FORMAT_DASH)] : []}
			/>
		</CalendarWrapper>
	);
};

export default Calendar;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CalendarWrapper = styled.div({
	boxShadow: token(
		'elevation.shadow.raised',
		'0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)',
	),
	borderRadius: '3px',
});
